import type { preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery$data } from './__generated__/preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery.graphql.ts';
// We are currently only SSRing inline Smart Links, all other types of Smart Links will be ignored
export const isInlineSmartLink = (node: any): boolean => {
	return node?.['__typename'] === 'InlineSmartLink';
};

export type SmartLinkType = {
	appearance: string;
	resourceUrl: string;
	title?: string | null;
	emojiTitle?: string | null;
	canView?: boolean | null;
	product?: string | null;
	resourceType?: string | null;
	subType?: string | null;
	iconUrl?: string | null;
	resolved?: boolean | null;
	statusText?: string | null;
	statusAppearance?: string | null;
};

type SmartLinkQueryData = preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery$data;

type SmartLinkNode =
	| NonNullable<NonNullable<SmartLinkQueryData['contentSmartLinks']>['nodes']>[number]
	| NonNullable<
			NonNullable<SmartLinkQueryData['confluence_contentSmartLinksForDraft']>['nodes']
	  >[number];

const parseSmartlinksResponse = (res: any, isDraft: boolean): SmartLinkNode[] => {
	if (isDraft) {
		return res?.data?.confluence_contentSmartLinksForDraft?.nodes || [];
	}
	return res?.data?.contentSmartLinks?.nodes || [];
};

// This function takes in a query response and returns an array of SmartLink resourceUrls
export const getSmartLinks = (res: any, isDraft = false): SmartLinkType[] => {
	const content = parseSmartlinksResponse(res, isDraft);

	// filter to only inline smartlins and limit to the max number of smartlinks allowed per call by ORS
	const inputSmartLinks = content.filter(isInlineSmartLink).slice(0, 50);

	return inputSmartLinks
		.filter((node) => !!node)
		.map((node) => {
			return {
				appearance: 'inline',
				resourceUrl: node?.url,
				title: node?.title,
				emojiTitle: node?.emojiTitle,
				canView: node?.canView,
				product: node?.product,
				resourceType: node?.resourceType,
				subType: node?.subType,
				iconUrl: node?.iconUrl,
				resolved: node?.resolved,
				statusText: node?.statusText,
				statusAppearance: node?.statusAppearance,
			};
		});
};
